<template>
  <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
    <zj-layout-main>
      <el-container style="height: 100%">
        <el-main class="main-content">
          <!-- <el-divider style="top: -18px"></el-divider> -->
          <el-header
            class="panel-header"
            style="text-align: left; padding: 4px 4px; height: 42px"
          >
            <!-- <div class="panel-tabs">
              <el-tabs
                class="custom-tabs"
                v-model="activeName"
                @tab-click="handleClick"
              >
                <el-tab-pane label="设备列表" name="first"></el-tab-pane>
              </el-tabs>
            </div> -->
            <div class="zj-button-bar">
              <el-button
                class="panel-header-button-left"
                size="small"
                @click="selectAllDevices"
                >全选</el-button
              >
              <el-button
                class="panel-header-button-right"
                @click="devicesInverse"
                size="small"
                >反选</el-button
              >
            </div>
          </el-header>
          <el-divider style="top: -18px"></el-divider>
          <div style="margin-top: 3rem">
            <el-row>
              <el-col :span="8" v-for="(item, index) in Devices" :key="index">
                <div
                  class="main-content-card"
                  @click="deviceClick(item, index)"
                  :class="
                    item.checked && item.IsEnabled
                      ? 'main-card-checked'
                      : item.IsEnabled
                      ? ''
                      : 'main-card-disabled'
                  "
                >
                  <!-- <div
                    :class="item.checked ? 'card-close el-icon-close' : ''"
                  ></div> -->
                  <div class="card-device">
                    <i
                      :class="
                        item.IsOnline
                          ? 'el-icon-my-broadcast_e'
                          : 'el-icon-my-broadcast_u'
                      "
                    ></i
                    >&nbsp;&nbsp;{{ item.DeviceName }}
                    <i
                      style="display: block"
                      v-if="item.TaskName != null || item.TaskName != ''"
                      >{{ item.TaskName }}</i
                    >
                    <i style="display: block">音量：{{ item.Volume }}</i>
                  </div>
                  <canvas
                    :id="`canvas${item.Id}`"
                    class="canvas"
                    width="350"
                    height="60"
                  ></canvas></div
              ></el-col>
            </el-row>
          </div>
        </el-main>
      </el-container>
    </zj-layout-main>
    <el-footer height="95px">
      <el-form
        ref="Form"
        :model="planData"
        :rules="rules"
        label-width="60px"
        style="width: 90%"
      >
        <el-row>
          <el-col :span="20">
            <el-form-item label="播放音量" prop="PlayVolume">
              <el-slider
                v-model="planData.PlayVolume"
                :disabled="!volumeSliderIsEnabled"
                @change="SetVolume"
              ></el-slider>
            </el-form-item>
          </el-col>
          <div style="padding-top: 1rem">
            <span>{{ planData.PlayVolume }}</span>
          </div>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="播放状态" prop="PlayStatus">
              <div>
                <span>{{ planData.PlayStatus }}</span>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <el-button
                type="primary"
                @click="startMIC0()"
                :disabled="!playMIC0IsEnabled"
                v-if="!isStart"
                >开启</el-button
              >
              <el-button
                type="primary"
                @click="stopMIC0()"
                :disabled="!stopMIC0IsEnabled"
                v-if="isStart"
                >关闭</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-footer>
    <el-dialog
      title="请选择寻呼台..."
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
      :append-to-body="true"
      style="text-align: left"
      :destroy-on-close="true"
      ><MICInfo
        :MICArray="mics"
        @clickCancel="clickCancel"
        @clickConfirm="clickConfirm"
      ></MICInfo>
    </el-dialog>
  </zj-layout-container>
</template>

<script>
import ZJApp from "../../../../../app";
import MyApis from "../../../apis";
import utils from "../../../../../../utils";
import MICInfo from "./MICInfo";
const ZJPlayer = ZJApp.ZJPlayer;
const MediaCenter = ZJPlayer.MediaCenter;
const MSG = ZJPlayer.MediaCenterMsg;
export default {
  name: "HomeViewBroadcastPanel",
  controller: "UI",
  action: "HomeViewBroadcastPanel",
  components: { MICInfo },
  props: {
    deviceId: String,
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      deviceName: null,
      EqRegionArr: [],
      DeviceList: [],
      Devices: [],
      expandedKeys: [],
      loading: false,
      loadingText: "",
      loadingTreeText: "",
      loadingAudioText: "",
      loadingAudio: false,
      activeName: "first",
      flag: false, // 属性是否选中标识
      content: "",
      voice: "",
      speed: 4,
      times: 1,
      volume: 0,
      planData: { PlayVolume: 0, PlayStatus: "关闭中" },
      isStart: false,
      result: false,
      serverConfig: [],
      endpoints: [],
      selectDevices: [],
      tempTaskId: null,
      tempMIC0TaskId: null,
      refreshIsEnabled: false, //刷新按钮禁用状态
      playMIC0IsEnabled: false, //麦克风
      stopMIC0IsEnabled: false, //麦克风
      volumeSliderIsEnabled: false, //音量
      deviceFlag: false,
      mics: [],
      dialogVisible: false,
      TextItem: null,
      msgRes: null,
    };
  },
  created: function () {
    this.mc = new MediaCenter({
      address: this.CNF("mediaCenter.extend.broadcast"),
    });
    this.mc.on("connected", () => this.onConnected());
    this.mc.on("msg", (e) => this.onRecv(e));
    this.mc.on("error", (e) => this.onError(e));
    this.handleLoad();
  },
  computed: {
    httpRequest() {
      return ZJApp.ZJApis.ZJUploader.upload;
    },
  },
  mounted: function () {
    this.init();
    // setTimeout(() => {
    //   this.init();
    // }, 1000);
  },

  methods: {
    //1、获取终端信息
    //2、获取广播设备信息
    //3、根据收到的终端消息，来更新设备信息（将终端信息合到设备信息上（前端操作数据））。
    //4、列表不展示配置的排除的设备信息，
    //初始化时同步设备
    init() {
      this.loading = true;
      //所属区域
      const that = this;
      utils
        .waitAll([
          // () => that.getRegionInfo(),
          () => that.getEquipments(),
          that.config.getUValue("BroadcastSubSystem:BroadcastServer:", ""),
        ])
        .then((r) => {
          // that.EqRegionArr = r[0].data.Data;
          that.DeviceList = r[0].data.Data;
          that.serverConfig = r[1].JValue;

          //绑定设备状态
          that.BindDeviceStatus();
          //排除设备
          const ExclusionEquip =
            that.serverConfig.filter((item) => {
              return item.ItemKey == "BroadcastServerExclusion";
            }) || [];
          const Exclusions = (ExclusionEquip[0].ItemValue || "").split(",");
          let mapE = {};
          Exclusions.forEach((element) => {
            mapE[element] = element;
          });
          that.Devices = [];
          that.DeviceList.forEach((item) => {
            if (!mapE[item.DeviceId]) {
              that.Devices.push(item);
            }
          });
          that.UpdateButtonState();
          // setTimeout(() => {
          //   that.UpdateButtonState();
          // }, 300);

          that.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });

      //  this.findPlayList();
    },

    convertToTreeNodes(list, regions) {
      //不改变原数组
      let result = JSON.parse(JSON.stringify(regions));

      for (let i = 0; i < list.length; i++) {
        var deviceData = list[i];
        var device = {
          id: deviceData.DeviceId,
          label: deviceData.DeviceName,
          pid: deviceData.RegionId,
          type: "Device",
          children: [],
        };
        for (let j = 0; j < result.length; j++) {
          if (result[j].id == deviceData.RegionId) {
            result[j].children.push(device);
          }
        }
      }

      return result;
    },

    //全选设备
    selectAllDevices() {
      const that = this;

      that.Devices.forEach((device, index) => {
        if (device != null && device.IsEnabled) {
          device.checked = true;
          that.$set(that.Devices, index, device);
        }
      });
    },
    //反选设备
    devicesInverse() {
      const that = this;

      that.Devices.forEach((device, index) => {
        if (device != null && device.IsEnabled) {
          device.checked = !device.checked;
          that.$set(that.Devices, index, device);
        }
      });
    },
    //获取设备列表
    getEquipments() {
      return new MyApis.BaseDataApi().GetEquipmentMangeList({
        EquipmentType: "Broadcast",
      });
    },
    //绑定设备状态
    BindDeviceStatus() {
      if (this.endpoints.length == 0 || this.DeviceList.length == 0) return;
      let mapP = {};
      this.endpoints.forEach((element) => {
        mapP[element.Id] = element;
      });
      this.DeviceList.forEach((dev) => {
        let ep = null;
        if (!mapP[dev.DeviceId]) {
          ep = null;
        } else {
          ep = mapP[dev.DeviceId];
        }
        this.UpdateDeviceInfo(dev, ep);
      });
    },
    //根据收到的终端消息，来更新设备信息。
    UpdateDeviceInfo(dest, src) {
      if (dest == null) return;
      if (src == null) {
        dest.TaskId = null;
        dest.TaskName = null;
        dest.TaskVolume = null;
        dest.State = -1; //故障
        dest.IsOnline = false;
        dest.IsEnabled = false;
        return;
      }
      dest.DeviceName = src.Name;
      dest.IsOnline = src.Online == 1;
      dest.TaskId = src.TaskId;
      dest.TaskName = src.TaskName;
      dest.TaskMessage = null;
      dest.Volume = src.Volume || 0;
      if (!dest.IsOnline) dest.State = -1;
      //故障
      else if (src.TaskId != null && src.TaskId != "") dest.State = 1;
      //占用
      //占用
      else dest.State = 0; //空闲
      dest.IsEnabled = dest.IsOnline;
      if (dest.DeviceId == this.deviceId) {
        dest.checked = true;
      }
    },
    UpdateDeviceInfoByEP(src) {
      var dest = this.Devices.filter((x) => x.DeviceId == src.Id);
      if (dest.length > 0) {
        this.UpdateDeviceInfo(dest[0], src);
      }
    },
    //根据收到的任务消息，来更新设备信息。
    UpdateDeviceInfoByTask(src) {
      const that = this;
      if (
        src == null ||
        src.TaskEndpointGroup == null ||
        src.TaskEndpointGroup.Length == 0
      )
        return;
      src.TaskEndpointGroup.forEach((ep) => {
        var dests = that.Devices.filter((x) => x.DeviceId == ep.Id);
        if (dests.length > 0) {
          var dest = dests[0];
          dest.TaskId = src.TaskId;
          dest.TaskName = src.TaskName;
          dest.TaskVolume = src.TaskVolume;
          dest.TaskType = src.TaskType;
          dest.TaskMessage = null;

          if (dest.TaskVolume <= 0) dest.TaskVolume = ep.Volume || 0;

          switch (ep.Status) {
            case 1:
              dest.IsOnline = true;
              if (dest.TaskName != null && src.TaskId != "")
                dest.TaskMessage = `"${ep.Name}开始${dest.TaskName}"`;
              break;
            case 2:
              dest.IsOnline = false;
              break;
            case 3:
              dest.IsOnline = true;
              if (dest.TaskName != null && src.TaskId != "")
                dest.TaskMessage = `"${ep.Name}被占用"`;
              break;
          }

          if (!dest.IsOnline) dest.State = -1;
          //故障
          else if (src.TaskId != "" && src.TaskId != null) dest.State = 1;
          //占用
          else dest.State = 0; //空闲
        }
      });
    },
    UpdateVolumeSlider() {
      let volume = 0;

      var selectedDevices = this.Devices.filter((x) => x.checked);
      if (selectedDevices.length == 0) {
        volume = 0;
      } else {
        // 选中设备中有播放任务，则仅显示最大任务音量，否则显示最大设备音量。
        if (selectedDevices.some((x) => x.TaskId != null && x.TaskId != "")) {
          var sd = selectedDevices.filter(
            (x) => x.TaskId != null && x.TaskId != ""
          );
          volume = Math.max.apply(
            Math,
            sd.map((item) => {
              return item.TaskVolume > 0 ? item.TaskVolume : item.Volume;
            })
          );
        } else {
          volume = Math.max.apply(
            Math,
            selectedDevices.map((item) => {
              return item.Volume;
            })
          );
        }
      }
      this.volume = volume;
    },
    UpdateButtonState() {
      const that = this;

      var devices = that.Devices.filter((x) => x.checked);

      that.refreshIsEnabled = that.endpoints.length > 0;

      that.playMIC0IsEnabled =
        that.endpoints.length > 0 && devices.length > 0 /* &&
                        !devices.Any(x => !string.IsNullOrEmpty(x.TaskId))*/;
      that.stopMIC0IsEnabled =
        that.endpoints.length > 0 &&
        devices.length > 0 &&
        devices.some((x) => x.TaskName == that.TASK_NAME_MIC0);
      that.volumeSliderIsEnabled =
        that.endpoints.length > 0 && devices.length > 0;
    },
    // 绑定设备状态
    deviceClick(item, index) {
      const delIndex = this.selectDevices.indexOf(item);
      item.checked = !item.checked;
      this.$set(this.Devices, index, item);
      if (item.checked) {
        // this.deviceFlag = true;
        this.UpdateButtonState();
        this.UpdateVolumeSlider();
        this.selectDevices.push(item);
      }
      if (delIndex > -1) {
        this.selectDevices.splice(delIndex, 1);
      }
      this.deviceFlag = true;
    },

    errmsg: function (message) {
      this.$message({
        type: "error",
        message: message,
      });
    },

    // 加载设备
    handleLoad() {
      this.tableData = [];
      this.loading = true;
      this.loadingText = "加载广播设备中...";
      if (this.mc.$connected) {
        this.beginGetEndpoints();
      } else {
        this.mc.connect().then(() => this.beginGetEndpoints());
      }
    },

    // 成功连接到媒体中心
    onConnected() {
      //this.beginGetRegions();
    },

    beginGetEndpoints() {
      // 发送命令：获取终端设备数据
      this.mc.sendCmd(MSG.Get_End_Points);
    },

    onError(e) {
      console.error(e);
      let msg = e && e.error && e.error.message ? e.error.message : e;
      this.$message.error("出错了: " + msg);
      this.loading = false;
    },

    // 接收到媒体中心的响应
    onRecv(e) {
      const msg = e.data;

      if (msg.isResponse()) {
        this.msgRes = msg;
        switch (msg.msgCode) {
          case MSG.Get_End_Points:
            this.onGetEndpoints(msg.getJsonData());
            break;
          case MSG.Start_Broadcast:
            var b = msg.getJsonData();

            if (b && b.code == "0" && b.data) {
              this.tempMIC0TaskId = b.data;
              this.isStart = true;

              this.$message.success("人工广播成功");
            } else {
              this.$message.error("人工广播失败");
            }
            break;

          case MSG.Set_Task_Volume:
            var tv = msg.getJsonData();

            if (tv && tv.code == "0" && tv.data) {
              this.$message.success("调节音量成功");
            } else {
              this.$message.error("调节音量失败");
            }
            break;
          case MSG.Set_End_Point_Volume:
            var ev = msg.getJsonData();

            if (ev && ev.code == "0" && ev.data) {
              this.$message.success("调节音量成功");
            } else {
              this.$message.error("调节音量失败");
            }
            break;

          case MSG.MP3_Set_Mode:
            var sm = msg.getJsonData();

            if (sm && sm.code == "0" && sm.data) {
              this.$message.success("设置播放模式成功");
            } else {
              this.$message.error("设置播放模式失败");
            }
            break;
          case MSG.Broadcast_Callback:
            // eslint-disable-next-line no-redeclare
            var r = msg.getJsonData();
            if (r && r.code == "0" && r.data) {
              this.PA_Msg(r.data);
            }
            break;
        }
      }
    },

    // 处理获取设备的响应
    onGetEndpoints(r) {
      this.endpoints = [];
      if (r && r.code == "0" && r.data) {
        const list = r.data;
        for (let i = 0; i < list.length; i++) {
          this.endpoints.push(list[i]);
        }

        if (this.endpoints.length >= list.length) {
          this.loadingText = "加载广播设备...100%";
          this.init();
        }
      } else {
        this.loading = false;
        console.error(r && r.msg ? r.msg : "未获取到设备信息");
        this.$message.error(r && r.msg ? r.msg : "出错了: 无设备信息");
      }
    },
    //开始人工广播
    startMIC0() {
      this.tempMIC0TaskId = null;
      var devices = this.Devices.filter((x) => x.checked);

      if (devices == null || devices.length <= 0) {
        this.$message.warning("请选择广播设备");
        return;
      }

      const MIC0 =
        this.serverConfig.filter((item) => {
          return item.ItemKey == "BroadcastServerMIC0";
        }) || [];
      const micArray = (MIC0[0].ItemValue || "").split(",");

      let sendEndpoint = null; //广播发起终端
      if (micArray.length == 0) {
        this.$message.warning("请先配置桌面寻呼台");
        return;
      } else if (micArray.length > 1) {
        this.dialogVisible = true;
      } else {
        sendEndpoint = micArray[0];
        let params = {
          sendEndPoint: sendEndpoint,
          receiveEndPoints: this.selectDevices.map((item) => {
            return item.DeviceId;
          }),
        };
        console.log(params);
        // this.sendCmd(MSG.Start_Broadcast, params);

        var deviceNameStr = this.selectDevices
          .map((item) => {
            return item.DeviceName;
          })
          .join("|");
        this.logInfo.ActionName = "开始人工广播";
        this.logInfo.LogMessage = `"播放人工广播 》》 ${deviceNameStr}"`;
        this.logInfo.ModuleName = "广播系统";
        this.logInfo.PageName = "手动广播";
        this.addOperationLog();
      }

      let mapM = {};
      micArray.forEach((element) => {
        mapM[element] = element;
      });
      this.mics = [];
      //不改变原数组
      let result = JSON.parse(JSON.stringify(this.DeviceList));
      result.forEach((item) => {
        if (mapM[item.DeviceId]) {
          this.mics.push(item);
        }
      });

      this.planData.PlayStatus = "开启中...";
    },
    //停止音乐广播
    stopMIC0() {
      this.isStart = false;
      var devices = this.Devices.filter((x) => x.checked);

      if (devices == null || devices.length <= 0) {
        this.$message.warning("请选择广播设备");
        return;
      }

      devices = devices.filter((x) => x.TaskName == this.TASK_NAME_MIC0);
      var taskIDs = devices.map((item) => {
        return item.TaskId;
      });
      if (taskIDs.length == 0) {
        this.$message.warning("选择的广播没有开启人工广播");
        return;
      }

      devices = this.Devices.filter(
        (x) =>
          x.TaskId != null &&
          x.TaskId != "" &&
          taskIDs.some((y) => y == x.TaskId)
      );
      taskIDs.forEach((item) => {
        this.sendCmd(MSG.Stop_Broadcast, { taskId: item });
      });

      var deviceNameStr = devices
        .map((x) => {
          return x.DeviceName;
        })
        .join("|");

      this.logInfo.ActionName = "停止人工广播播放";
      this.logInfo.LogMessage = `"停止人工广播播放》》 ${deviceNameStr}"`;
      this.logInfo.ModuleName = "广播系统";
      this.logInfo.PageName = "手动广播";
      this.addOperationLog();
    },
    clickCancel() {
      this.dialogVisible = false;
    },
    clickConfirm(data) {
      this.dialogVisible = false;
      let params = {
        sendEndPoint: data,
        receiveEndPoints: this.selectDevices.map((item) => {
          return item.DeviceId;
        }),
      };
      this.sendCmd(MSG.Start_Broadcast, params);

      var deviceNameStr = this.selectDevices
        .map((item) => {
          return item.DeviceName;
        })
        .join("|");
      this.logInfo.ActionName = "开始人工广播";
      this.logInfo.LogMessage = `"播放人工广播 》》 ${deviceNameStr}"`;
      this.logInfo.ModuleName = "广播系统";
      this.logInfo.PageName = "手动广播";
      this.addOperationLog();
    },
    //调节设备音量
    SetVolume() {
      var devices = this.Devices.filter((x) => x.checked);

      if (devices == null || devices.length <= 0) {
        this.$message.warning("请选择广播设备");
        return;
      }
      // 选中设备中有播放任务，则仅调节任务音量（跳过未播放的设备），否则调节设备音量。
      if (
        devices.some((x) => {
          return x.TaskId != null && x.TaskId != "";
        })
      ) {
        //调节任务音量
        var taskDevs = devices.filter(
          (x) => x.TaskId != null && x.TaskId != ""
        );
        taskDevs.forEach((item) => {
          this.sendCmd(MSG.Set_Task_Volume, {
            taskId: item.TaskId,
            volume: this.volume,
          });
        });
      } else {
        //调节设备音量
        devices.forEach((item) => {
          this.sendCmd(MSG.Set_End_Point_Volume, {
            ipv4: JSON.parse(item.JsonExtend).IP,
            volume: this.volume,
          });
        });
      }
    },
    sendCmd(cmd, params) {
      if (this.mc.$connected) {
        this.mc.sendCmd(cmd, params);
      } else {
        this.mc.connect().then(() => {
          this.mc.sendCmd(cmd, params);
        });
      }
    },
    //响应终端信息
    PA_Msg(msg) {
      switch (msg.EventType) {
        case 1: //终端状态变化，音量或任务
          {
            var endpoint = msg.Data;
            this.UpdateDeviceInfoByEP(endpoint);
            setTimeout(() => {
              this.UpdateButtonState();
            }, 300);
          }
          break;
        case 2: //任务终端信息返回
        case 3: //任务信息编号：终端上下线、被占用状态
          {
            var task = msg.Data;
            this.UpdateDeviceInfoByTask(task);
            setTimeout(() => {
              this.UpdateButtonState();
              this.drawCanvas(task);
            }, 300);
          }
          break;

        case 4: //MP3 播放进度，播放歌曲信息
          {
            var playerInfo = msg.Data;
            console.log(playerInfo);
          }
          break;

        case 5: //任务停止
          {
            var taskId = msg.Data;

            var devices = this.Devices.filter((x) => x.TaskId == taskId);
            var ids = devices.map((item) => {
              return item.Id;
            });
            this.clearCanvas(ids);
            if (devices != null || devices.length > 0) {
              devices.forEach((dev) => {
                dev.TaskId = null;
                dev.TaskName = null;
                dev.TaskVolume = null;
                dev.TaskType = 0;
                dev.State = 0;
              });
            }

            setTimeout(() => {
              this.UpdateButtonState();
            }, 300);
          }
          break;

        case 6: //开始对讲
        case 7: //结束对讲
          break;
      }
    },
    refreshStatus() {
      this.init();
    },
    drawCanvas(src) {
      //找到播放任务中对应的canvasid
      var dests = this.Devices.filter((x) => x.TaskId == src.TaskId);
      var ids = dests.map((item) => {
        return item.Id;
      });

      ids.forEach((item) => {
        this.draw(item);
      });
    },
    draw(id) {
      var canvas = document.getElementById("canvas" + id);
      var context = canvas.getContext("2d");

      canvas.width = 350;
      canvas.height = 60;
      var WIDTH = canvas.width;
      var HEIGHT = canvas.height;
      var bufferLength = 64; // = fftSize * 0.5
      var dataArray = this.msgRes.msgData;

      //part4: 变量
      //  var barWidth = (WIDTH / dataArray.length) * 2.5; //间隔1px
      var barWidth = WIDTH / bufferLength - 1; //间隔1px
      var barHeight = 0;

      context.fillStyle = "transparent"; //透明背景
      context.fillRect(0, 0, WIDTH, HEIGHT);
      //part6: 绘画声压条
      var x = 0;
      for (var i = 0; i < bufferLength; i++) {
        var index = Math.floor(Math.random() * dataArray.length);
        var data = dataArray[index];

        var percentV = data / 255; //纵向比例
        var percentH = i / bufferLength; //横向比例

        barHeight = HEIGHT * percentV;

        //gbk,0~255
        var r = 255 * percentV; //值越大越红
        var g = 255 * percentH; //越靠右越绿
        var b = 50;

        context.fillStyle = "rgb(" + r + "," + g + "," + b + ")";
        context.fillRect(x, HEIGHT - barHeight, barWidth, barHeight);

        x += barWidth + 1; //间隔1px
      }
    },
    //清除画布
    clearCanvas(ids) {
      ids.forEach((item) => {
        var canvas = document.getElementById("canvas" + item);
        var context = canvas.getContext("2d");
        context.clearRect(0, 0, canvas.width, canvas.height);
      });
    },
  },
  destroyed() {
    this.mc.close();
  },
};
</script>
<style lang="scss">
.panel_aside {
  padding: 0px 20px 20px 20px;
  .el-tree {
    background-color: transparent;

    border-width: 1;

    * {
      background-color: transparent;
    }
  }
  .el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    background-color: rgba(61, 159, 255, 0.2);
  }
  .el-checkbox__inner {
    border-radius: 50%;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    border-radius: 50%;
    background: -webkit-radial-gradient(
      circle closest-side,
      #409eff 60%,
      transparent 40%
    );
  }

  .el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner::after {
    border-color: transparent;
  }
}
.panel-header {
  text-align: left;
  padding: 4px 4px;
  height: 42px;
  .panel-tabs {
    float: left;
    .el-tabs__active-bar.is-top {
      left: 50%;
      width: 3rem !important;
      transform: translateX(-50%) !important;
    }
    .custom-tabs.el-tabs--top .el-tabs__active-bar {
      bottom: 1rem;
      height: 0.5rem;
      background-color: #409eff;
      border-radius: 0.5rem;
      box-shadow: 0 -0.3rem 0.5rem rgba(64, 158, 255, 0.7);
    }

    .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
      padding-left: 0rem;
    }
    .custom-tabs.el-tabs--top .el-tabs__item.is-active {
      color: #2bc5ff;
      font-size: 1.8rem;
      font-weight: bold;
    }
  }

  .panel-header-button-left {
    background-color: transparent;
  }
  .panel-header-button-left:hover {
    background: rgba(61, 159, 255, 0.2);
  }
  .panel-header-button-right {
    background-color: transparent;
    border-color: rgb(217, 72, 77);
    color: rgb(217, 72, 77);
  }
  .panel-header-button-right:hover {
    background: rgba(217, 72, 77, 0.2);
  }
}
.main-content {
  padding: 0;
  .main-card-checked {
    border: 1px solid rgb(61, 159, 255);
  }
  .main-card-disabled {
    pointer-events: none;
  }
  .main-content-card {
    position: relative;
    height: 8rem;
    padding: 0.7rem;
    background-color: rgba(61, 159, 255, 0.2);
    margin: 5px;
    cursor: pointer;
    .card-close {
      float: right;
      margin-top: -0.5rem;
      margin-right: -0.5rem;
    }
    .card-device {
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
      white-space: nowrap;
    }
    .el-icon-my-broadcast_e {
      background: url("../../../../../../assets/broadcast_e.png") center
        no-repeat;
      background-size: cover;
    }
    .el-icon-my-broadcast_e:before {
      content: "\5e7f";
      font-size: 16px;
      visibility: hidden;
    }

    .el-icon-my-broadcast_u {
      background: url("../../../../../../assets/broadcast_u.png") center
        no-repeat;
      background-size: cover;
    }
    .el-icon-my-broadcast_u:before {
      content: "qu";
      font-size: 14px;
      visibility: hidden;
    }

    .main-content-card-content {
      margin-left: 24px;
      margin-top: 4px;
    }
  }
}
.el-icon-my-play {
  background: url("../../../../../../assets/play.png") center no-repeat;
  background-size: cover;
}
.el-icon-my-play:before {
  content: "\5f00";
  font-size: 12px;
  visibility: hidden;
}
.el-icon-my-pause {
  background: url("../../../../../../assets/pause.png") center no-repeat;
  background-size: cover;
}
.el-icon-my-pause:before {
  content: "\6682";
  font-size: 12px;
  visibility: hidden;
}
// .vulume_adjust {

// }
.el-tooltip__popper.is-dark {
  background: rgb(0, 35, 69) !important;
}
.el-tooltip__popper.popper__arrow {
  border-width: 0;
  background-color: #3d9fff;
  border-color: #3d9fff;
}
.el-tooltip__popper[x-placement^="top"] .popper__arrow:after {
  border-top-color: #3d9fff;
}
.table-music /deep/.el-table__body-wrapper {
  height: 100% !important;
}
.table-music {
  .el-checkbox__inner {
    border-radius: 50%;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    border-radius: 50%;
    background: -webkit-radial-gradient(
      circle closest-side,
      #409eff 60%,
      transparent 40%
    );
  }

  .el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner::after {
    border-color: transparent;
  }
}
.custom-tree-node {
  .el-icon-my-broadcast_e {
    background: url("../../../../../../assets/broadcast_u.png") center no-repeat;
    background-size: cover;
    margin-left: 5px;
  }
  .el-icon-my-broadcast_e:before {
    content: "qu";
    font-size: 12px;
    visibility: hidden;
  }
}
.el-checkbox.is-checked + .custom-tree-node {
  .el-icon-my-broadcast_e {
    background: url("../../../../../../assets/broadcast_e.png") center no-repeat;
    background-size: cover;
    margin-left: 5px;
  }
  .el-icon-my-broadcast_e:before {
    content: "\5e7f";
    font-size: 15px;
    visibility: hidden;
  }
  .custom-tree-node-label {
    color: rgb(32, 149, 226);
  }
}
.panel-right-font {
  color: #2bc5ff;
  font-size: 1.8rem;
}
.panel-right-mode {
  margin-top: 10px;
  text-align: right;
}
.panel-right {
  .panel-right-speed {
    margin-right: 2px;
  }
  .panel-right-times {
    margin-left: 10px;
    margin-right: 2px;
  }
}

.canvas {
  // position: fixed;
  left: 10;
  top: 10;
  width: 100%;
  height: 66%;
}
</style>
